import React from 'react';
import ButtonBase from '@mui/material/ButtonBase';
import Tooltip from '@mui/material/Tooltip';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { usePanelCollapseHandleStyles } from 'components/OrderSlidesList/SlideActionTabs/ActionPanelsContainer/styles';

/**
 * The strip between the slide and the metadata/comments panel. It is the
 * whole height of the panel, labelled, and reads "Hide" or "Show panel"
 * depending on the state, so the collapse is found without hovering.
 */
export const PanelCollapseHandle = ({ isCollapsed, onToggle }) => {
  const { classes, cx } = usePanelCollapseHandleStyles();
  const label = isCollapsed ? 'Show panel' : 'Hide';
  const Icon = isCollapsed ? KeyboardArrowLeft : KeyboardArrowRight;

  return (
    <Tooltip
      title={isCollapsed ? 'Show the panel ( ] )' : 'Hide the panel ( ] )'}
      placement="left"
    >
      <ButtonBase
        className={cx(classes.handle, isCollapsed && classes.handleCollapsed)}
        onClick={onToggle}
        aria-label={isCollapsed ? 'Show panel' : 'Hide panel'}
        aria-expanded={!isCollapsed}
        data-testid="panel-collapse-handle"
        focusRipple
      >
        <Icon className={classes.icon} fontSize="inherit" />
        <span className={classes.label}>{label}</span>
      </ButtonBase>
    </Tooltip>
  );
};
